import { Controller } from "@hotwired/stimulus"

/**
 * region-switch — dismissible "you're in <region>" prompt shown on the region
 * landing pages when the visitor's geo-region differs from the page they are on.
 *
 * This is the crawler-safe replacement for the old IP redirect: an IP redirect
 * on `/` sent Googlebot (which crawls from US IPs) to `/us`, so `/` could never
 * be indexed as the AU page. The server decides whether to render the banner at
 * all (_region_suggestion); this controller only remembers a dismissal in
 * localStorage so it stays gone across Turbo visits and hard reloads.
 */
export default class extends Controller {
  static values = { code: String }

  connect() {
    if (this._dismissed()) {
      this.element.hidden = true
    }
  }

  dismiss() {
    try {
      localStorage.setItem(this._storageKey(), "1")
    } catch {
      // localStorage unavailable (private mode): just hide for this view.
    }
    this.element.hidden = true
  }

  _storageKey() {
    return `chippie:region-switch-dismissed:${this.codeValue}`
  }

  _dismissed() {
    try {
      return localStorage.getItem(this._storageKey()) === "1"
    } catch {
      return false
    }
  }
}
